import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
	import { useComputedStyle } from '@/HostApp/services/SystemLayout/SystemLayoutModule';

	
	const __default__ = {
		name: 'ComputedGrid',
		inheritAttrs: false
	};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		grid: {
			type: Object as PropType<LAYOUT.IGrid>,
			required: true
		}
	},
  setup(__props) {

const props = __props

	

	const computedStyle = computed(() => useComputedStyle(props.grid));
	const computedListeners = computed(() => props.grid.listeners || {});

return { __sfc: true,props, computedStyle, computedListeners }
}

})